import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import { ChakraProvider } from "@chakra-ui/react";

ReactDOM.createRoot(document.getElementById('root')!).render(
<React.StrictMode>
	<ChakraProvider>
		<App />
	</ChakraProvider>
</React.StrictMode>
)
